import { call, put, takeEvery } from "redux-saga/effects";

import {
  VEHICLE_LIST,
  VEHICLE_FILTER,
  VEHICLE_CREATE,
  VEHICLE_UPDATE,
} from "store/vehicles/actionTypes";

import {
  vehicleListSuccess,
  vehicleCreateSuccess,
  vehicleUpdateSuccess,
  vehicleRequestFailed,
} from "store/vehicles/actions";

import {
  getVehicleList,
  getVehicleFilter,
  postVehicleCreate,
  patchVehicleUpdate,
} from "connection/backend";

function* vehicleListSaga() {
  console.log("Trayendo lista de vehículos...");
  try {
    const response = yield call(getVehicleList);
    if (response.status === 200) {
      yield put(vehicleListSuccess(response.data));
    } else {
      yield put(vehicleRequestFailed(response.data));
    }
  } catch (error) {
    yield put(vehicleRequestFailed(error.response.data));
  }
}

function* vehicleCreateSaga({ payload: vehicle }) {
  console.log("Creando nuevo vehículo...");
  try {
    const response = yield call(postVehicleCreate, vehicle);
    if (response.status === 201) {
      yield put(vehicleCreateSuccess(response.data));
    } else {
      yield put(vehicleRequestFailed(response.data));
    }
  } catch (error) {
    yield put(vehicleRequestFailed(error.response.data));
  }
}

function* vehicleFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getVehicleFilter, { changeUrl });
    if (response.status === 200) {
      yield put(vehicleListSuccess(response.data));
    } else {
      yield put(vehicleRequestFailed(response.data));
    }
  } catch (error) {
    yield put(vehicleRequestFailed(error.response.data));
  }
}

function* vehicleUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos del vehiculo...");
  try {
    const response = yield call(patchVehicleUpdate, { id }, data);
    if (response.status === 200) {
      yield put(vehicleUpdateSuccess(response.data));
    } else {
      yield put(vehicleRequestFailed(response.data));
    }
  } catch (error) {
    yield put(vehicleRequestFailed(error.response.data));
  }
}

export default function* vehicleSaga() {
  yield takeEvery(VEHICLE_LIST, vehicleListSaga);
  yield takeEvery(VEHICLE_FILTER, vehicleFilterSaga);
  yield takeEvery(VEHICLE_CREATE, vehicleCreateSaga);
  yield takeEvery(VEHICLE_UPDATE, vehicleUpdateSaga);
}
